import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr(""); setLoading(true);
    try {
      const u = await login(email, password);
      toast.success("Welcome back.");
      if (u.role === "admin") navigate("/admin");
      else navigate("/dashboard");
    } catch (e) { setErr(e.message); }
    setLoading(false);
  };

  return (
    <div className="section-dark min-h-screen flex items-center py-16">
      <div className="container-app grid md:grid-cols-2 gap-12">
        <div>
          <div className="label-tag mb-4">Login</div>
          <h1 className="font-heading font-black uppercase text-5xl md:text-7xl leading-none"><span className="metallic-gold">Welcome</span><br/>back to work.</h1>
          <p className="mt-8 text-white/70 max-w-md">Log in to manage your profile, videos, event registrations, and recruiting activity.</p>
        </div>
        <div className="card-dark p-10">
          <form onSubmit={submit} className="space-y-8">
            <div>
              <label className="label-tag" style={{ color: "#A3A3A3" }}>Email</label>
              <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="input-sharp mt-2" data-testid="login-email-input" />
            </div>
            <div>
              <label className="label-tag" style={{ color: "#A3A3A3" }}>Password</label>
              <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} className="input-sharp mt-2" data-testid="login-password-input" />
            </div>
            {err && <div className="text-red-400 text-sm" data-testid="login-error">{err}</div>}
            <button disabled={loading} className="btn-gold w-full justify-center" data-testid="login-submit-btn">{loading ? "…" : "Log In"}</button>
            <div className="text-white/60 text-sm">No account? <Link to="/register" className="text-[color:var(--gold)] hover:underline" data-testid="link-register">Join now</Link></div>
          </form>
        </div>
      </div>
    </div>
  );
}
